import { Component } from '@angular/core';
import { ROUTER_DIRECTIVES } from '@angular/router';
import { HeaderService } from '../header/header.service';
import { Router } from '@angular/router';

declare const jQuery: any;

@Component({
  selector: 'header',
  // templateUrl : '/header.html',
  template: require('./header.html'),
  directives: [ROUTER_DIRECTIVES],
  providers: [HeaderService]

})
export class HeaderComponent {

  constructor(private _headerService: HeaderService, private _router: Router) {

  }
  private values = '';
  private limit = 10;
  private offset = 0;
  private data = 0;
  private blur_close = false;
  private activity: any;
  private recentactivity: any;
  private recentactivityloader = false;
  private recentactivityactivity = false;
  private userData: any;
  search_person = false;
  search_hashtag = false;
  search_location = false;

  ngOnInit() {
    var token = localStorage.getItem('authToken');
    if (!token)
      this._router.navigate(["login"]);
    // console.log("hiiiii...");
    this._headerService.recentactivitypeople(this.limit, this.offset)
      .subscribe((res) => {
        // console.log(res);
        // if (res.code == 401){

        //   // console.log("hiiiiissss...");
        //   // var token = localStorage.removeItem('authToken');
        //   // var username = localStorage.removeItem('username');
        //   // this._router.navigate(['login']);
        // }

        this.activity = res.data;
        this.commentfunction();
      });



  }

  recentactivityy() {
    this.recentactivityactivity = true;
  }

  commentfunction() {
    var len = this.activity.length;
    for (var i = 0; i < len; i++) {
      var post = this.activity[i].createdOn;
      var poston = Number(post);
      var postdate = new Date(poston);
      var currentdate = new Date();
      var timeDiff = Math.abs(postdate.getTime() - currentdate.getTime());
      var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      var diffHrs = Math.round((timeDiff % 86400000) / 3600000);
      var diffMins = Math.round(((timeDiff % 86400000) % 3600000) / 60000);

      if (1 < diffDays) {
        this.activity[i].createdOn = diffDays + "d";
      } else if (1 <= diffHrs) {
        this.activity[i].createdOn = diffHrs + "h";
      } else {
        this.activity[i].createdOn = diffMins + "m";
      }

      // this.activity.push(this.recentactivity[i]);
    }
  }

  memberprofile(item: any): void {
    var personname = item.membername;
    var username = localStorage.getItem('username');
    if (username == personname) {
      this._router.navigate(['home/profile']);
    }
    else {
      let link = ['home/person', personname];
      this._router.navigate(link);
    }
    this.blur_close = false;
  }

  memberprofileactivity(item: any): void {
    var person_name = item.membername;
    var personname = item.username;
    var postId = item.postId;
    if (postId) {
      //console.log(personname, postId);
      let link = ['home/homepost', personname, postId];
      this._router.navigate(link);
    }
    else {
      let link = ['home/person', person_name];
      this._router.navigate(link);
    }
    // var username = localStorage.getItem('username');
    // if (username == personname) {
    //     this._router.navigate(['home/profile']);
    // }
    // else {
    //     let link = ['home/person', personname];
    //     this._router.navigate(link);
    // }
    this.blur_close = false;
  }


  memberprofilehashtag(item: any): void {
    var personname = item.hashTagName;
    var username = localStorage.getItem('username');
    let link = ['home/personcaption', personname];
    this._router.navigate(link);
    this.blur_close = false;
  }

  memberprofilelocation(item: any): void {
    var personname = item.placename;
    var username = localStorage.getItem('username');
    let link = ['home/personlocation', personname];
    this._router.navigate(link);
    this.blur_close = false;
  }



  onKey(value: string, limit: any, offset: any) {
    this.values = value;
    if (value.length > 0) {
      if (this.values.charAt(0) == '#') {
        var hashtag_regexp = /#([a-zA-Z0-9_]+)/g;
        this.values = this.values.replace(hashtag_regexp, '$1');
        // //console.log(search_text);
        this._headerService.searchpeople(this.values, this.limit, this.offset)
          .subscribe((res) => {
            this.search_person = false;
            this.search_hashtag = true;
            this.search_location = false;
            this.data = res.data;
            if (res.data.userData[0]) {
              this.userData = res.data.hashTagData[0].hashTagName;
            }
          });
      } else if (this.values.charAt(0) == '@') {
        var hashtag_regexp = /@([a-zA-Z0-9_]+)/g;
        this.values = this.values.replace(hashtag_regexp, '$1');
        // //console.log(search_text);
        this._headerService.searchpeople(this.values, this.limit, this.offset)
          .subscribe((res) => {
            this.search_person = true;
            this.search_hashtag = false;
            this.search_location = false;
            this.data = res.data;
            if (res.data.userData[0]) {
              this.userData = res.data.userData[0].membername;
            }
          });
      } else {
        this._headerService.searchpeople(this.values, this.limit, this.offset)
          .subscribe((res) => {
            this.search_person = true;
            this.search_hashtag = true;
            this.search_location = true;
            this.data = res.data;
            if (res.data.userData[0]) {
              this.userData = res.data.userData[0].membername;
            }
            //  //console.log(res.data.userData[0].membername);
          });

      }
    }


  }
  usersearchSubmit(value: any, data: any) {
    // //console.log(this.userData);
    var searchname = this.userData;
    if (value.charAt(0) == '#') {
      let link = ['home/personcaption', searchname];
      this._router.navigate(link);
      this.blur_close = false;
    } else if (value.charAt(0) != '#') {
      if (searchname) {
        let link = ['home/person', searchname];
        this._router.navigate(link);
        this.blur_close = false;
      } else {
        let link = ['home/person', value];
        this._router.navigate(link);
        this.blur_close = false;
      }
    }
  }

  blursearch() {
    // alert("hai");
    setTimeout(() => {
      jQuery("#searchPico").val('');
      this.blur_close = false;
    }, 200);
  }
  searchopen() {
    // alert("hi");
    this.blur_close = true;
  }

}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/header/header.component.ts
 **/